import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';
import { useFormikContext } from 'formik';

const Slope = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  const { setFieldValue } = useFormikContext();

  return (
    <FormikInput
      id="slope"
      name="slope"
      label="Slope Percentage"
      disabled={!isEnableInfoTabEdit}
      placeholder="Enter slope percentage"
      onChange={e => setFieldValue('slope', e.target.value)}
    />
  );
};

export default Slope;
